import PortalIdParser from 'PortalIdParser';
/** Response when creating a contact list via a ListsClient endpoint */

/**
 * Get the ListsClient or InboundDbListsClient-specific portion of the endpoint
 * path based on the user having the necessary gate.
 * @param hasListsClientMigrationGate Indicates if the user has the `LISTS_CLIENT_MIGRATION` gate
 * @returns The value to use in the endpoint's path (e.g., `ads/v1/<return value here>/...`)
 */
export const getListsClientEndpointPath = hasListsClientMigrationGate => {
  return hasListsClientMigrationGate ? 'object-lists' : 'contact-lists';
};
/**
 * Get the URL path for navigating a user to their new contact list.
 * @param hasListsClientMigrationGate Indicates if the user has the `LISTS_CLIENT_MIGRATION` gate
 * @param listId The list's ID
 * @returns The URL path to the list
 */

export const getContactListUrlPath = (hasListsClientMigrationGate, listId) => {
  return hasListsClientMigrationGate ? `/contacts/${PortalIdParser.get()}/objectLists/${listId}/` : `/lists/${PortalIdParser.get()}/list/${listId}/`;
};
/**
 * Standardize the output of a request made to create a contact list. If the
 * request is successful, this function returns a partial ListsClientResponse.
 * @param request The API request for creating a contact list
 * @param listName The list's name
 * @returns A partial ListsClientResponse
 */

export const handleContactListCreationRequest = (request, listName) => {
  return new Promise((resolve, reject) => {
    request.then(response => {
      if (response.portalId) {
        return resolve(response);
      }

      return resolve({
        name: listName,
        staticListId: Number(response.id)
      });
    }).catch(error => reject(error));
  });
};